
import phone1 from '../assets/images/phone/login.jpg'
import phone2 from '../assets/images/phone/anasayfa.jpg'
import phone3 from '../assets/images/phone/destek.jpg'
import phone4 from '../assets/images/phone/gruplar.jpg'
import phone5 from '../assets/images/phone/kesfet.jpg'
import phone6 from '../assets/images/phone/profil.jpg'

import client1 from '../assets/images/client/login.jpg'
import client2 from '../assets/images/client/anasayfa.jpg'
import client3 from '../assets/images/client/destek.jpg'
import client4 from '../assets/images/client/gruplar.jpg'
import client5 from '../assets/images/client/kesfet.jpg'
import client6 from '../assets/images/client/profil.jpg'



import { FiDatabase, FiEye, FiFeather, FiHeart, FiMaximize, FiMonitor, FiNavigation2, FiPieChart, FiSmartphone, FiUserCheck } from "react-icons/fi"

export const feature = [
    {
        icon:FiMaximize,
        title:'Hatim Takip Sistemi',
        desc:'Bireysel ya da grup bazlı Kur’an hatimlerinin organize edilmesini ve takip edilmesini sağlar.',
        active:true
    },
    {
        icon:FiPieChart,
        title:'Grup Oluşturma ve Yönetimi',
        desc:'Kullanıcılar kendi hatim gruplarını kurabilir, katılımcıları davet edebilir ve yönetebilir.',
        active:false
    },
    {
        icon:FiNavigation2,
        title:'Cüz Yönetimi',
        desc:'Hangi cüzün kimde olduğunu, tamamlanma durumunu ve okuma sırasını detaylı şekilde görüntüleme.',
        active:true
    },
    {
        icon:FiDatabase,
        title:'Otomatik Cüz Dağıtımı',
        desc:'Gruplarda yeni katılımcılara sistem tarafından uygun cüz otomatik olarak atanır.',
        active:false
    },
]

export const feature2 = [
    {
        icon:FiMonitor,
        title:'Use On Any Device',
        desc:'One disadvantage of Lorum Ipsum is that in Latin frequently than others'
    },
    {
        icon:FiFeather,
        title:'Feather Icons',
        desc:'One disadvantage of Lorum Ipsum is that in Latin frequently than others'
    },
    {
        icon:FiEye,
        title:'Retina Ready',
        desc:'One disadvantage of Lorum Ipsum is that in Latin frequently than others'
    },
]
export const feature3 = [
    {
        icon:FiUserCheck,
        title:'W3c Valid Code',
        desc:'One disadvantage of Lorum Ipsum is that in Latin frequently than others'
    },
    {
        icon:FiSmartphone,
        title:'Fully Responsive',
        desc:'One disadvantage of Lorum Ipsum is that in Latin frequently than others'
    },
    {
        icon:FiHeart,
        title:'Browser Compatibility',
        desc:'One disadvantage of Lorum Ipsum is that in Latin frequently than others'
    },
]

export const screenshotImg = [
    phone1, phone2, phone3, phone4, phone5, phone6
]

export const faq = [
    {
        id:1,
        title:'Nasıl çalışır?',
        desc:'Uygulamamız, Kur\'an-ı Kerim ve Risale-i Nur hatimlerinizi bireysel veya grup halinde kolayca takip etmenizi sağlayan basit ve kullanıcı dostu bir arayüze sahiptir.'
    },
    {
        id:2,
        title:'Grup oluşturmak için ne yapmam gerekiyor?',
        desc:'Uygulamaya giriş yaptıktan sonra "Grup Oluştur" butonuna tıklayarak kendi hatim grubunuzu kolayca kurabilir ve arkadaşlarınızı davet edebilirsiniz.'
    },
    {
        id:3,
        title:'Hatim takibi nasıl yapılır?',
        desc:'Oluşturduğunuz veya katıldığınız hatim grubunda, size atanan cüzleri işaretleyerek ilerlemenizi kaydedebilir ve diğer katılımcıların da ilerlemesini görebilirsiniz.'
    },
    {
        id:4,
        title:'Hatim tamamlandığında ne olur?',
        desc:'Grup üyelerinin tüm cüzleri tamamlamasıyla hatim bitirilmiş olur. Tamamlanan hatimler arşivinizde saklanır ve hatim duası için bildirim alırsınız.'
    },
]

export const clientData = [
    {
        image:client1,
        name:'Calvin Carlo',
        position:'Manager',
        desc:`" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:client2,
        name:'Christa Smith',
        position:'Manager',
        desc:`" The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:client3,
        name:'Jemina CLone',
        position:'Manager',
        desc:`" One disadvantage of Lorum Ipsum is that in Latin certain letters appear more frequently than others. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:client4,
        name:'Smith Vodka',
        position:'Manager',
        desc:`" Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:client5,
        name:'Cristino Murfi',
        position:'Manager',
        desc:`" There is now an abundance of readable dummy texts. These are usually used when a text is required. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:client6,
        name:'Cristino Murfi',
        position:'Manager',
        desc:`" According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
]

